/** Tokens visuais — Formulário de Paciente Klinvia (frontend-design + agendaTheme) */
import { AGENDA_THEME } from '../../pages/agendaTheme';

export const PATIENT_FORM_THEME = {
  ...AGENDA_THEME,
  sectionTitle: AGENDA_THEME.tealDark,
} as const;

export const patientFormClinicalGridBg = {
  backgroundColor: PATIENT_FORM_THEME.muted,
  backgroundImage: `
    linear-gradient(${PATIENT_FORM_THEME.gridLine} 1px, transparent 1px),
    linear-gradient(90deg, ${PATIENT_FORM_THEME.gridLine} 1px, transparent 1px)
  `,
  backgroundSize: '24px 24px',
};

export const patientFormDialogPaperSx = (isMobile: boolean) =>
  isMobile
    ? undefined
    : {
        borderRadius: 3,
        maxHeight: '95vh',
        border: `1px solid ${PATIENT_FORM_THEME.borderSoft}`,
        boxShadow: PATIENT_FORM_THEME.dialogShadow,
        overflow: 'hidden',
      };

export const patientFormDialogHeaderSx = {
  ...patientFormClinicalGridBg,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderBottom: `1px solid ${PATIENT_FORM_THEME.borderSoft}`,
  flexShrink: 0,
  px: { xs: 2, sm: 3 },
  py: { xs: 1.5, sm: 2 },
};

export const patientFormDialogTitleSx = {
  fontWeight: 700,
  color: PATIENT_FORM_THEME.navy,
  letterSpacing: '-0.02em',
};

export const patientFormHeaderIconSx = {
  color: PATIENT_FORM_THEME.teal,
  flexShrink: 0,
};

export const patientFormCloseButtonSx = {
  color: PATIENT_FORM_THEME.slate,
  '&:hover': { bgcolor: PATIENT_FORM_THEME.mutedAlt },
};

export const patientFormDialogContentSx = {
  flex: 1,
  overflow: 'auto',
  px: { xs: 2, sm: 3 },
  bgcolor: PATIENT_FORM_THEME.paper,
};

export const patientFormTabsSx = {
  mb: 2,
  minHeight: { xs: 44, sm: 48 },
  '& .MuiTab-root': {
    textTransform: 'none' as const,
    fontWeight: 600,
    minWidth: { xs: 'auto', sm: 90 },
    color: PATIENT_FORM_THEME.slate,
  },
  '& .MuiTab-root.Mui-selected': { color: `${PATIENT_FORM_THEME.tealDark} !important` },
  '& .MuiTabs-indicator': {
    bgcolor: PATIENT_FORM_THEME.teal,
    height: 3,
    borderRadius: '3px 3px 0 0',
  },
};

export const patientFormSectionTitleSx = {
  fontWeight: 700,
  color: PATIENT_FORM_THEME.sectionTitle,
  mb: 0.5,
};

export const patientFormCaptionSx = {
  color: PATIENT_FORM_THEME.slate,
};

export const patientFormCaptionMutedSx = {
  color: PATIENT_FORM_THEME.slateMid,
};

export const patientFormDividerCaptionSx = {
  color: PATIENT_FORM_THEME.slateFaint,
};

export const patientFormPrimaryButtonSx = {
  bgcolor: PATIENT_FORM_THEME.teal,
  '&:hover': { bgcolor: PATIENT_FORM_THEME.tealDark },
  textTransform: 'none' as const,
  fontWeight: 600,
};

export const patientFormCancelButtonSx = {
  color: PATIENT_FORM_THEME.slate,
  textTransform: 'none' as const,
};

export const patientFormDialogFooterSx = {
  p: { xs: 2, sm: 2.5 },
  flexShrink: 0,
  gap: 1,
  flexWrap: 'wrap' as const,
  borderTop: `1px solid ${PATIENT_FORM_THEME.borderSoft}`,
  bgcolor: PATIENT_FORM_THEME.muted,
  flexDirection: { xs: 'column-reverse', sm: 'row' } as const,
  justifyContent: 'flex-end',
};

export const patientFormCheckboxSx = {
  color: PATIENT_FORM_THEME.slateFaint,
  '&.Mui-checked': { color: PATIENT_FORM_THEME.teal },
};
